import { WarningFilled } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import DocumentationModal from "../../../DocumentationModal/DocumentationModal";
import { Tooltip } from "antd";
import dayjsTZ from "../../../../../../../utils/dayjs";
import "./DocumentationCard.scss";
import PunonjesitContext from "../../../../../../punonjesit/store/PunonjesitContext";
import { useSelector } from "react-redux";

const DocumentationCard = ({ doc, key, openAutomatically }) => {
  const { isDarkMode } = useSelector((state) => state.usersList);

  const { categoryConfiguration } = useContext(PunonjesitContext);

  const { docType, docStatus, googleDriveUploads, createdAt } = doc;
  const [documentationModalVisible, setDocumentationModalVisible] = useState(
    !!openAutomatically
  );

  const filesUploaded = googleDriveUploads.length;

  //* checks if docName is equal with docType
  const { docStatuses = [] } =
    categoryConfiguration?.documentationsAvailable?.find(
      ({ docName }) => docName === docType
    ) || {};
  //* finds status name color and documentation status and displays it
  const { statusColor: backgroundColor } =
    docStatuses?.find(({ statusName }) => statusName === docStatus) || {};

  const TEXT = !!filesUploaded
    ? `${filesUploaded} ${
        filesUploaded?.length > 1 ? "Skedarë të ngarkuar" : "Skedar i ngarkuar"
      }`
    : "Mungojnë Skedarët";

  return (
    <>
      <div
        className={`documentationViewCard ${isDarkMode ? "dark" : ""}`}
        onClick={() => setDocumentationModalVisible(true)}
        key={key}
      >
        <Tooltip className="statusCardOverlay" title={docType}>
          <span className="docTitle">
            <div>{docType}</div>
            <div className="docCreationTime">
              {dayjsTZ(createdAt).format("DD/MM/YYYY")}
            </div>
          </span>
        </Tooltip>
        <div className="leftSection">
          <div
            className="docStatusLabel"
            style={{
              backgroundColor: backgroundColor || "#dce4e9",
              color: backgroundColor ? "#fff" : "#1d3445",
            }}
          >
            {docStatus}
          </div>
          <div
            className={`uploadedFilesLabel ${!filesUploaded ? "noFiles" : ""}`}
          >
            {!filesUploaded && <WarningFilled className="warningIcon" />}
            <span>{TEXT}</span>
          </div>
        </div>
      </div>
      {!!documentationModalVisible ? (
        <DocumentationModal
          doc={doc || {}}
          {...{
            visible: documentationModalVisible,
            setVisible: setDocumentationModalVisible,
            docStatuses,
          }}
        />
      ) : null}
    </>
  );
};

export default DocumentationCard;
